"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const RangeUtilities_1 = require("../../../../data/utilities/RangeUtilities");
const DispatchContext_1 = require("../../../context/DispatchContext");
const EditableColumn_1 = __importDefault(require("../../../elements/EditableColumn"));
const formatNumber_1 = require("../../../utility/formatNumber");
function RelativeColumn({ row, rowSpanTags, onHover, format, }) {
    const dispatch = (0, DispatchContext_1.useDispatch)();
    const flag = (0, RangeUtilities_1.checkRangeKind)(row);
    const formattedValue = (0, formatNumber_1.formatNumber)(row.integration, format);
    const integralVal = flag ? formattedValue : `[ ${formattedValue} ]`;
    function saveHandler(event) {
        dispatch({
            type: 'CHANGE_RANGE_RELATIVE',
            payload: {
                value: event.target.value,
                id: row.id,
            },
        });
    }
    return ((0, jsx_runtime_1.jsx)("td", { ...rowSpanTags, ...onHover, children: (0, jsx_runtime_1.jsx)(EditableColumn_1.default, { value: integralVal, onSave: saveHandler, validate: (val) => val !== '', type: "number", style: { padding: '0.1rem 0.4rem' } }) }));
}
exports.default = RelativeColumn;
